import { TableCard } from '@/components/common/table/TableCard'
import { PaginationFooter } from '@/components/common/table/PaginationFooter'
import { AbsenceEntriesDataTable } from './AbsenceEntriesDataTable'
import type { AbsenceEntriesController } from '../hooks/useAbsenceEntries'

interface Props {
  entries: AbsenceEntriesController
  /** Approve/reject visible only with ServiceModules.Edit on the module. */
  canEdit: boolean
}

/**
 * Shared table card of the absence list (table + pagination), fed by
 * `useAbsenceEntries`. Used identically by the "all absences" and the employee
 * page — the filters above them differ, the table does not.
 */
export function AbsenceEntriesTable({ entries, canEdit }: Props) {
  return (
    <TableCard>
      <div className="flex-1 overflow-auto scrollbar-custom relative">
        <AbsenceEntriesDataTable
          rows={entries.rows}
          isLoading={entries.isLoading}
          isError={entries.isError}
          currentSort={entries.sort}
          currentOrder={entries.order}
          onSort={entries.onSort}
          updatingId={entries.updatingId}
          onUpdateStatus={entries.updateStatus}
          canEdit={canEdit}
        />
      </div>

      <PaginationFooter
        offset={entries.offset}
        limit={entries.limit}
        totalCount={entries.totalCount}
        onOffsetChange={entries.onOffsetChange}
        onPageSizeChange={entries.onPageSizeChange}
      />
    </TableCard>
  )
}
